import CartProductsTable from "./CartProductsTable";
import CheckoutButton from "../CheckoutButton";

const MiniCart = () => {
	return (
		<div className="flex flex-col">
			<CartProductsTable />
			<div className="flex w-full items-center justify-between px-8 mt-5">
				<div></div>
				<CheckoutButton />
			</div>
		</div>
	);
};

export default MiniCart;
